import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { PayoutType } from "types/enums";

export const usePayoutTypeSelectOptions = () => {
    const { t } = usePaldockTranslation("general.payout_type");

    const options = Object.entries(PayoutType).map(([key, value]) => ({
        label: t(key.toLowerCase()),
        value: value,
    }));

    return { options, loading: false, error: null };
};
